import { createAction, props } from '@ngrx/store';
import { IColorsList } from '@interfaces';
export const loadColors = createAction('[Colors] Load Colors');
export const loadColorsSuccess = createAction('[Colors] Load Colors Success', props<{ colors: IColorsList[] }>());
export const loadColorsFailure = createAction('[Colors] Load Colors Failure', props<{ error: string }>());
